import { Component } from "../components/index"
import { qsa, qs } from "../utils/index"

export default class ProductInfo extends Component {
  constructor(obj) {
    super(obj)

    this.labels = qsa(".productInfo-label", this.el)
    this.tabs = qsa(".productInfo-tab", this.el)
    this.smooth = obj.renderer.smooth || false
  }

  toggleTabs(e) {
    const target = e.target
    const labelid = target.dataset.label
    const tabid = qs(`[data-tab="${labelid}"]`, this.el)

    this.labels.forEach(label => {
      label.classList.remove("active")
    })

    this.tabs.forEach(tab => {
      tab.classList.remove("active")
    })

    tabid.classList.add("active")
    target.classList.add("active")

    requestAnimationFrame(() => {
      this.smooth?.update()
    })
  }

  on() {
    this.labels.forEach(label => {
      label.addEventListener("click", e => this.toggleTabs(e))
    })
  }
}
